angular.module('impactx.disposition').controller('DispositionCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    '$mdToast',
    'selectedListItems',
    '$redirect',
    'ToolbarService',
    'basketTemplateMenu',
    'ToastService',
    'TranslationService',
    'TemplateNameService',
    DispositionCtrl]);

function DispositionCtrl($scope, dataGen, $routeParams, $mdToast, selectedListItems, $redirect, ToolbarService, basketTemplateMenu, ToastService, TranslationService, TemplateNameService) {
    var dehId = 0;
    var self = this;
    if ($routeParams.id) {
        dehId = $routeParams.id;
    }
    else {
        dehId = selectedListItems.getFirstSelectedId();
    }
    $scope.selectedPurchaseItems = [];
    $scope.getPageData = function () {
        dataGen.getData($scope, {id: dehId}, "/disposition/view", function () {
            $scope.data.object.comments.internalComments.newComments = [];
            defineButtons();
        });
    };

    $scope.getPageData();

    $scope.showItemComments = {value: false};
    self.toggleItemComment = function () {
        $scope.showItemComments.value = !$scope.showItemComments.value;
    };
    $scope.showHeaderComment = {value: false};
    self.toggleComment = function () {
        $scope.showHeaderComment.value = !$scope.showHeaderComment.value;
    };
    $scope.showComments = {value: false};
    $scope.selectedSupplier = [];

    self.toggleSupplierComment = function () {
        $scope.showComments.value = !$scope.showComments.value;
    };

    self.selectSupplier = function (event, supplier) {
        if (event.target.tagName != "MD-SELECT" &&
            (!event.target.parentNode.tagName || event.target.parentNode.tagName != "MD-SELECT-VALUE")
            && (!event.target.parentNode.tagName || !event.target.parentNode.parentNode.tagName || event.target.parentNode.parentNode.tagName != "MD-SELECT-VALUE")) {
            $scope.showComments.value = false;
            for (var i = 0; i < $scope.selectedPurchaseItems.length; i++) {
                $scope.selectedPurchaseItems[i].selected = false;
            }
            $scope.selectedPurchaseItems.splice(0, 1);

            if ($scope.selectedSupplier[0] !== supplier) {
                $scope.selectedSupplier[0] = supplier;
            }
            else {
                $scope.selectedSupplier.splice(0, 1);
            }
        }
    };

    self.redirectToApprovalModified = function () {
        var id = $scope.selectedPurchaseItems[0].id;
        $redirect.redirectTo(null, '/approvalmodifieddei/' + id);
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.comments,
                action: self.toggleComment,
                type: 'dialogaction',
                condition: hasNoItemsSelected
            },
            {
                label: $scope.trns.comments,
                action: self.toggleItemComment,
                type: 'dialogaction',
                condition: hasItemsSelected
            },
            {
                label: $scope.trns.comments,
                action: self.toggleSupplierComment,
                type: 'dialogaction',
                condition: hasSupplierSelected
            },
            {
                label: $scope.trns.approvalmodified,
                action: self.redirectToApprovalModified,
                type: 'dialogaction',
                condition: canRedirectToApproval
            },
            {
                label: $scope.trns.createTemplate,
                action: self.createBasketTemplate,
                type: 'dialogaction',
                condition: canCreateTemplate
            },
            {
                label: $scope.trns.print,
                type: 'print',
                params: {
                    printToken: $scope.printTokens.demand
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function hasNoItemsSelected() {
        return !$scope.selectedPurchaseItems.length && !$scope.selectedSupplier.length;
    }

    function hasItemsSelected() {
        return $scope.selectedPurchaseItems.length > 0;
    }

    function hasSupplierSelected() {
        return $scope.selectedSupplier.length > 0;
    }

    function canRedirectToApproval() {
        return $scope.selectedPurchaseItems.length == 1 && $scope.selectedPurchaseItems[0].showApprovalModifiedLink;
    }

    function canCreateTemplate() {
        return $scope.data.object.canCreateTemplate;
    }

    this.createBasketTemplate = function() {
        TemplateNameService.showTemplateName(selectedListItems.getSelectedItems(), '/basket/template/beforecreatefromdemand', event).then(function(answer){
            if(answer)
            {
                dataGen.postAsForm({}, {items: [{id: dehId}], name: answer}, '/basket/template/createfromdemand').then(function()
                {
                    basketTemplateMenu.refreshAllTemplates();
                    ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                });
            }
        });
    }
}